/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import TableInGoldStandardsTables from '../model/TableInGoldStandardsTables';

/**
* GoldStandard service.
* @module endpoints/GoldStandardApi
* @version 2.8.0
*/
export default class GoldStandardApi {

    /**
    * Constructs a new GoldStandardApi. 
    * @alias module:endpoints/GoldStandardApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get Gold Standard table list
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TableInGoldStandardsTables>} and HTTP response
     */
    getGoldStandardsTablesWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [TableInGoldStandardsTables];
      return this.apiClient.callApi(
        '/goldStandards/tables', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get Gold Standard table list
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TableInGoldStandardsTables>}
     */
    getGoldStandardsTables() {
      return this.getGoldStandardsTablesWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
